function apiUrl(hostname) {
  switch (hostname) {
    case "ops.cloosiv.com":
      // cloosiv production
      return "https://api.cloosiv.com";
    case "test-admin.cloosiv.com":
      // cloosiv stage
      return "https://test-api.cloosiv.com";
    case "admin-orderahead.odeko.com":
      // odeko production
      return "https://api-orderahead.odeko.com";
    case "admin-orderahead-stage.odeko.com":
      // odeko stage
      return "https://api-orderahead-stage.odeko.com";
    case "admin-orderahead-stage-2.odeko.com":
      // odeko stage
      return "https://api-orderahead-stage-2.odeko.com";
    default:
      // development
      return process.env.VUE_APP_API_URL || 'http://localhost:8089';
  }
}

function graphqlApiUrl(hostname) {
  switch (hostname) {
    case "ops.cloosiv.com":
      // cloosiv production
      return "https://graphql.odeko.com";
    case "test-admin.cloosiv.com":
      // cloosiv stage
      return "https://graphql-stage.odeko.com";
    case "admin-orderahead.odeko.com":
      // odeko production
      return "https://graphql.odeko.com";
    case "admin-orderahead-stage.odeko.com":
      // odeko stage
      return "https://graphql-stage.odeko.com";
    case "admin-orderahead-stage-2.odeko.com":
      // odeko stage-2
      return "https://graphql-stage-2.odeko.com";
    default:
      // development
      return process.env.VUE_APP_GRAPHQL_API_URL || 'http://localhost:8080';
  }
}

export default function () {
  return {
    apiUrl: apiUrl(window.location.hostname),
    graphqlApiUrl: graphqlApiUrl(window.location.hostname),
  };
}
